<!--title-->
<h2 mat-dialog-title>
  <i class="material-icons m-r-10">notifications_none</i>
  <span>{{'Layout.RightNavbar.Notifications.Details.Title' | translate}}</span>
</h2>

<!--content-->
<mat-dialog-content>

  @if (_currentNotification) {
    <div>
      <h3>{{_currentNotification.title}}</h3>
      <p class="clearfix">{{_currentNotification.message}}</p>
    </div>
    <hr class="mt-30 mb-10" />
    <ul class="notify-details--list clearfix">
      <li><strong>{{'Layout.RightNavbar.Notifications.Details.From' | translate}}:</strong> {{_currentNotification.senderName}}</li>
      <li><strong>{{'Layout.RightNavbar.Notifications.Details.To' | translate}}:</strong> {{_currentNotification.recipientName}}</li>
    </ul>
    <ul class="notify-details--list clearfix">
      <li><strong>{{'Layout.RightNavbar.Notifications.Details.Sent' | translate}}:</strong> {{_currentNotification.insertDate | date: 'dd/MM/yyyy HH:mm:ss'}}</li>
      @if (_currentNotification.readingDate) {
        <li><strong>Letta:</strong> {{_currentNotification.readingDate | date: 'dd/MM/yyyy HH:mm:ss'}}</li>
      }
    </ul>
  }

</mat-dialog-content>

<!--actions-->
<mat-dialog-actions>
  @if (_currentNotification && _currentNotification.link && _currentNotification.type == 'in' && !_isMobile) {
    <button mat-flat-button mat-ripple color="accent" (click)="followLink(_currentNotification.link)">
      <mat-icon class="m-r-10">arrow_right_alt</mat-icon>
      {{'Layout.RightNavbar.Notifications.Details.FollowLink' | translate}}
    </button>
  }
  <button type="button" mat-dialog-close mat-button mat-ripple>
    {{'Commons.Actions.Close' | translate}}
  </button>
</mat-dialog-actions>